import React from 'react';
import StyledGridFilterPanel from './Styled/StyledGridFilterPanel';
import { Stack, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { headingFontBold } from '../../../Theme';

export default () => {
    const { t } = useTranslation('translations', { keyPrefix: 'docTable' });
    return (
        <Stack>
            <Typography sx={{ ...headingFontBold, fontSize: '18px', p: 2 }}>
                {t('advancedFilter')}
            </Typography>
            <StyledGridFilterPanel />
        </Stack>
    );
};
